import React from "react";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import {
    errorMessage,
} from "../../../util/Helpers";
import cogoToast from "cogo-toast";

export const UserRelationshipsTable = ({profileId, side}) => {

   
    const profileIdToFetch = profileId 

    const renderUser = (row) => {
        return (
            <div className="d-flex align-items-center">
                <div className="symbol symbol-40 symbol-circle symbol-light-primary overflow-hidden mr-3">
                    {row.imageUrl ? (
                        <img src={row.imageUrl} alt={row.displayName} style={{objectFit: 'cover'}} />
                    ) : (
                        <span className="symbol-label font-size-h5 font-weight-bold">
                            {row.displayName?.[0]?.toUpperCase() || "U"}
                        </span>
                    )}
                </div>
                <div className="d-flex flex-column">
                    <span className="text-dark-75 font-weight-bolder font-size-lg">
                        {row.displayName || "Unknown User"}
                    </span>
                    <span className="text-muted font-weight-bold font-size-sm">
                        @{row.username || "username"}
                    </span>
                </div>
            </div>
        );
    };

    return (
        <DynamicSimpleTable
            key={`${profileIdToFetch} ${side}`}
            queryParams={`limit=${10}`}
            searchBox={false}
            isSequential={true}
            source={{ url: `/social/profiles/${profileIdToFetch}/${side}` }}
            columns={[
                {
                    title: "User",
                    format: renderUser,
                },
                { title: "Profile ID", key: "profileId" },
                {
                    title: "Level",
                    key: "userLevel",
                    format: (row) => (
                        <span className={`label label-lg label-inline ${row.userLevel === 'power' ? 'label-light-danger' : 'label-light-primary'} font-weight-bold`}>
                            {row.userLevel || "N/A"}
                        </span>
                    )
                },
            ]}
            onError={(err) => cogoToast.error(errorMessage(err))}
            refreshIcon={true}
        />
    );
};
